import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseApiTemplateService, Core2Config, ApiVisa, BasicApiResponseModel } from "../../shared";
import { EntityFileExportContainerModel } from "../../../../../../models/aggregates/erp/entity/entity-file-export-container.model";
import { EntityCriteriaDTO } from "../../../data-transfer-objects";

@Injectable({ providedIn: "root" })
export class EntityFileExportService extends BaseApiTemplateService<EntityFileExportContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "entity-exports/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "entity-exports/backoffice-ep";
    this.httpClient = http;
  }

  generateEntityExportFile(entityType: string, dtoObject: EntityCriteriaDTO, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + entityType + '/generate-csv';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl,dtoObject,this.getHttpHeader(visa));
  }

  downloadReport(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/' + guid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }
} 
